const accessSales = {

    WISHLIST_LIST: { name: 'Wishlist', path: '/wishlist-list' },

    CART_LIST: { name: 'Cart', path: '/cart-list' },

    ORDER_LIST: { name: 'Order', path: '/order-list' },
    ORDER_DETAILS: { name: 'Order Details', path: '/order-details' },
    UPDATE_ORDER: { name: 'Update Order', path: '/update-order' },

    CONTACT_US_LIST: { name: 'Contact Us', path: '/contact-us-list' },
    CONTACT_US_DETAILS: { name: 'Contact Us Details', path: '/contact-us-details' },

}

export default accessSales;